module.exports = __webpack_public_path__ + "img/canada-cervical-cancer-female.de538e34.png";